import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import * as React from 'react';
import { Trans } from 'react-i18next';
import { rejectPaymentResponsibility } from './actions';
import { useDispatch } from 'react-redux';
import { UIProperty } from '@api/v1';

export const RejectingPaymentResponsibilityDialog = ({
	open,
	property,
	closeRejectingDialog
}: {
	open: boolean;
	property: UIProperty | null;
	closeRejectingDialog: () => void;
}) => {
	const dispatch = useDispatch();

	return (
		<Dialog open={open}>
			<DialogTitle>
				<Trans
					i18nKey="properties:rejecting_payment_responsibility_dialog_header"
					values={{ propertyName: property ? property.name : '' }}
				/>
			</DialogTitle>
			<DialogContent>
				<Trans i18nKey="properties:rejecting_payment_responsibility_dialog_content" />
			</DialogContent>
			<DialogActions>
				<Button onClick={() => closeRejectingDialog()}>
					<Trans i18nKey="general:cta_cancel" />
				</Button>
				<Button
					color="primary"
					disabled={property?.id === null}
					onClick={() => {
						if (property?.id !== null) {
							dispatch(rejectPaymentResponsibility(String(property.id)));
							closeRejectingDialog();
						}
					}}
				>
					<Trans i18nKey="properties:rejecting_payment_responsibility_button" />
				</Button>
			</DialogActions>
		</Dialog>
	);
};
